import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  SquaresFour,
  UsersFour,
  Calendar,
  Stack,
  Megaphone,
  Ticket,
  User,
  ListChecks,
  ChartBar,
  Article,
  Lightbulb,
  Lightning,
  SignOut,
} from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: SquaresFour, end: true },
  { to: "/admin/leads", label: "Leads", icon: UsersFour },
  { to: "/admin/idealab", label: "IdeaLab", icon: Lightbulb },
  { to: "/admin/consultations", label: "Consultations", icon: Calendar },
  { to: "/admin/demos", label: "Demos", icon: Stack },
  { to: "/admin/promotions", label: "Promotions", icon: Megaphone },
  { to: "/admin/event-codes", label: "Event codes", icon: Ticket },
  { to: "/admin/reports", label: "Reports", icon: ChartBar },
  { to: "/admin/content", label: "Content", icon: Article },
  { to: "/admin/features", label: "Features", icon: Lightning },
  { to: "/admin/users", label: "Users", icon: User },
  { to: "/admin/audit", label: "Audit log", icon: ListChecks },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-zinc-50" data-testid="admin-layout">
      <aside className="w-64 border-r border-zinc-200 bg-white flex flex-col fixed h-screen">
        <div className="px-6 py-5 border-b border-zinc-200">
          <div className="flex items-center gap-2.5">
            <img src="/appistry-logo.png" alt="Appistry" className="h-9 w-9 object-contain" />
            <div>
              <div className="text-base font-bold tracking-tight leading-none" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Appistry
              </div>
              <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mt-1">Workbench</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto" data-testid="admin-sidebar">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
              data-testid={`sidebar-${l.label.toLowerCase()}`}
            >
              <l.icon size={18} weight="regular" />
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-zinc-200 p-4">
          <div className="text-xs font-mono text-zinc-500 mb-2">Signed in as</div>
          <div className="text-sm font-medium truncate" data-testid="admin-user-email">{user?.email}</div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mt-0.5">{user?.role?.replace("_", " ")}</div>
          <button
            onClick={handleLogout}
            className="mt-4 w-full flex items-center justify-center gap-2 border border-zinc-200 py-2 text-sm font-medium hover:bg-zinc-50"
            data-testid="admin-logout-btn"
          >
            <SignOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-h-screen" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
